import React, { PureComponent } from "react";
import "./index.css";
import GridTableFooter from "../GridUsuario/GridTableFooter";
import api from "../../Services/api";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import { FaPen, FaCopy, FaList, FaSearch, FaPlus } from "react-icons/fa";
import ModalPrincipal from "../../components/ModalAlert/modal";
import GridFiltersBar from "../GridUsuario/GridFiltersBar";
import TaskPageOptions from "./TaskPageOptions";
import GridHeroActions from "../GridUsuario/GridHeroActions";
import TaskGridLoadingPanel from "./TaskGridLoadingPanel";
import "../GridUsuario/index.css";
import "../GridUsuario/grid-view-responsive.css";


const STORAGE_KEY = "task_filters";

export class Child extends PureComponent {
  constructor(props) {
    super(props);

    this.requestSeq = 0;

    this.state = {
      isLoading: true,
      tableData: [],
      orgtableData: [],
      perPage: 100,
      currentPage: 0,
      pagAtual: 1,
      pageCount: 0,
      length: 0,
      forcePage: 0,
      isChecked: [],
      clickedtask: false,
      token: false,
      Nacesso: false,

      // 🔍 filtros
      tsk_active: "1",
      tsk_id: "",
      tea_id: "",
      age_id: "",
      loc_id: "",
      ast_id: "",
      tsk_integrationid: "",
      stn_id: "",
      tsk_observation: "",
      tty_id: "",
      crt_id: "",
      pvt_id: "",
      pla_id: "",
      startdate: "",
      enddate: "",
      startdateUlt: "",
      enddateUlt: "",
      search: "",
      mobileViewMode: "grid",
    };
  }

  toggleMobileViewMode = () => {
    this.setState((prev) => ({
      mobileViewMode: prev.mobileViewMode === "grid" ? "card" : "grid",
    }));
  };

  /* =====================================================
     🔐 FILTROS
  ===================================================== */

  getFilters = () => ({
    tsk_active: this.state.tsk_active,
    tsk_id: this.state.tsk_id,
    tea_id: this.state.tea_id,
    age_id: this.state.age_id,
    loc_id: this.state.loc_id,
    ast_id: this.state.ast_id,
    tsk_integrationid: this.state.tsk_integrationid,
    stn_id: this.state.stn_id,
    tsk_observation: this.state.tsk_observation,
    tty_id: this.state.tty_id,
    crt_id: this.state.crt_id,
    pvt_id: this.state.pvt_id,
    pla_id: this.state.pla_id,
    startdate: this.state.startdate,
    enddate: this.state.enddate,
    startdateUlt: this.state.startdateUlt,
    enddateUlt: this.state.enddateUlt,
    search: this.state.search,
    perPage: this.state.perPage,
    page: this.state.forcePage,
  });

  saveFilters = () => {
    secureLocalStorage.setItem(STORAGE_KEY, JSON.stringify(this.getFilters()));
  };

  restoreFilters = () => {
    const saved = secureLocalStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  };

  funcNsolicitacao = () => {
    this.setState({ Nacesso: false });
  }

  handleInputChangeAtivo = (event) => {

    if (this.props.pag === "task") {
      this.setState({ tsk_active: event.target.value });
    }
  }

  clear_search = () => {
    secureLocalStorage.removeItem(STORAGE_KEY);

    this.setState(
      {
        tsk_active: "1",
        tsk_id: "",
        tea_id: "",
        age_id: "",
        loc_id: "",
        ast_id: "",
        tsk_integrationid: "",
        stn_id: "",
        tsk_observation: "",
        tty_id: "",
        crt_id: "",
        pvt_id: "",
        pla_id: "",
        startdate: "",
        enddate: "",
        startdateUlt: "",
        enddateUlt: "",
        search: "",
        forcePage: 0,
      },
      () => this.getData(0)
    );
  };

  /* =====================================================
     🔄 LIFE CYCLE
  ===================================================== */

  componentDidMount() {
    const filters = this.restoreFilters();

    if (filters) {
      this.setState(
        {
          ...filters,
          forcePage: filters.page ?? 0,
        },
        () => this.getData(filters.page ?? 0)
      );
    } else {
      this.getData(0);
    }

    if (this.props.pag === "task") {
      this.GetTeam();
      this.GetAgent();
      this.GetLocal();
      this.GetAsset();
      this.GetTasksituation();
      this.GetTasktype();
      this.GetCorrectivetype();
      this.GetPreventivetype();
    }
  }

  areAllChecked = () => {
    const currentIds = this.state.tableData.map((tdata) => String(Object.values(tdata)[this.props.col8]));
    return currentIds.length > 0 && currentIds.every((id) => this.state.isChecked.includes(id));
  };

  GetTasksituation() {

    let valor

    api.get(this.props.tasksituation).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;

        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.stn_id), label: user.stn_description });
        });

        this.setState({
          optionsTasksituation: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsTasksituation: []
        });

      });
  }

  GetPreventivetype() {

    let valor

    api.get(this.props.preventivetype).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;

        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.pvt_id), label: user.pvt_description });
        });

        this.setState({
          optionsPreventivetype: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsPreventivetype: []
        });

      });
  }

  GetCorrectivetype() {

    let valor

    api.get(this.props.correctivetype).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;

        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.crt_id), label: user.crt_description });
        });

        this.setState({
          optionsCorrectivetype: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsCorrectivetype: []
        });

      });
  }

  GetTasktype() {

    let valor

    api.get(this.props.tasktype).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;

        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.tty_id), label: user.tty_description });
        });

        this.setState({
          optionsTasktype: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsTasktype: []
        });

      });
  }

  GetTeam() {

    let valor

    api.get(this.props.team).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;

        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.tae_id), label: user.tae_description });
        });

        this.setState({
          optionsTeam: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsTeam: []
        });

      });
  }

  GetAgent() {

    let valor

    api.get(this.props.user).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;


        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.age_id), label: user.age_name });
        });



        this.setState({
          optionsAgent: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsAgent: []
        });

      });
  }

  GetLocal() {

    let valor

    api.get(this.props.local).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;


        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.loc_id), label: user.loc_description });
        });



        this.setState({
          optionsLocal: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsLocal: []
        });

      });
  }

  GetAsset() {

    let valor

    api.get(this.props.asset).then((res) => {
      var data = res.data.data;
      if (res.data.status === 200) {

        valor = res.data.data;

        const arr = [];
        let result = valor;
        result.map((user) => {
          return arr.push({ value: String(user.ast_id), label: user.ast_description });
        });

        this.setState({
          optionsAsset: arr
        });

      }

    })
      .catch(function (res) {
        this.setState({
          optionsAsset: []
        });

      });
  }

  componentWillUnmount() {
    this.requestSeq += 1;
  }

  getData = (selectedPage = 0) => {
    const seq = ++this.requestSeq;

    this.setState({ isLoading: true, isChecked: [], forcePage: selectedPage }, () =>
      this.saveFilters()
    );

    const dados = [
      {
        ...this.getFilters(),
        page: selectedPage,
        loc_responsibletechnician: secureLocalStorage.getItem("vw"),
        age_responsibletechnician: secureLocalStorage.getItem("iag"),
      },
    ];

    api.defaults.headers.common["Authorization"] =
      secureLocalStorage.getItem("tpcm");

    api
      .get(this.props.endPoint, { params: { data: dados } })
      .then((res) => {
        if (seq !== this.requestSeq) return;

        const data = res.data.data || [];
        const total = res.data.total || data.length;

        this.setState({
          tableData: data,
          orgtableData: data,
          pageCount: Math.ceil(total / this.state.perPage),
          length: total,
          currentPage: selectedPage,
          pagAtual: selectedPage + 1,
          isLoading: false,
        });
      })
      .catch(() => {
        if (seq !== this.requestSeq) return;

        this.setState({
          tableData: [],
          pageCount: 0,
          length: 0,
          isLoading: false,
          Nacesso: true,
        });
      });
  };

  do_search = () => {
    this.setState({ isChecked: [] }, () => {
      this.props.cancelarTask?.([]);
      this.getData(0);
    });
  };
  
  handlePageClick = (e) => {
    this.setState(
      {
        isChecked: [], // 🔥 limpa seleção
      },
      () => {
        this.props.cancelarTask?.([]); // 🔥 informa o pai (se existir)
        this.getData(e.selected);
      }
    );
  };
  

  /* =====================================================
     🎛 UI
  ===================================================== */

  exibirFiltro = () =>
    this.setState((prev) => ({ clickedtask: !prev.clickedtask }));

  hasActiveFilters = () => {
    const s = this.state;
    return Boolean(
      s.search ||
        s.tsk_id ||
        s.tea_id ||
        s.age_id ||
        s.loc_id ||
        s.ast_id ||
        s.tsk_integrationid ||
        s.tsk_observation ||
        s.tty_id ||
        s.crt_id ||
        s.pvt_id ||
        s.pla_id ||
        s.startdate ||
        s.enddate ||
        s.startdateUlt ||
        s.enddateUlt ||
        s.stn_id ||
        s.tsk_active !== "1"
    );
  };

  handleSituationFilterChange = (value) => {
    this.setState({ stn_id: value }, () => this.getData(0));
  };

  /* =====================================================
     📄 RENDER (SEU JSX FOI MANTIDO)
  ===================================================== */

  toggleSelectAll = (e) => {
    const { checked } = e.target;

    // Use a chave correta para o ID:
    const currentIds = this.state.tableData.map((tdata) => String(tdata.tsk_accesstoken)); // <-- ajuste aqui

    this.setState((prevState) => ({
      isChecked: checked
        ? [...new Set([...prevState.isChecked, ...currentIds])]
        : prevState.isChecked.filter(id => !currentIds.includes(id)),
    }), () => {

      this.props.cancelarTask(this.state.isChecked);
    });
  };

  handleCheckbox = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;

    this.setState((prevState) => {
      const newChecked = checked
        ? [...prevState.isChecked, value]
        : prevState.isChecked.filter((id) => id !== value);
      return { isChecked: newChecked };
    }, () => {
      // Aqui o estado já está atualizado
      this.props.cancelarTask(this.state.isChecked);

    });
  };

  getSelectValue = (options = [], value) => {
    if (!value || !options.length) return null;
    return options.find(opt => String(opt.value) === String(value)) || null;
  };

  renderSelectField = (label, options, value, onValueChange, customStyles, selectTheme) => (
    <label className="grid-usuario__field">
      <span>{label}</span>
      <Select
        maxMenuHeight={150}
        placeholder="Selecione..."
        options={options || []}
        styles={customStyles}
        onChange={(opt) => onValueChange(opt ? opt.value : "")}
        value={this.getSelectValue(options, value)}
        isClearable
        noOptionsMessage={() => "Não encontrado..."}
        theme={selectTheme}
      />
    </label>
  );

  renderAdvancedFilters = (customStyles, selectTheme) => (
    <div className="grid-usuario__advanced">
      <div className="grid-usuario__advanced-grid">
        <label className="grid-usuario__field">
          <span>Ativo</span>
          <select
            value={this.state.tsk_active}
            onChange={(e) => this.setState({ tsk_active: e.target.value })}
          >
            <option value="">Todos</option>
            <option value="1">Sim</option>
            <option value="0">Não</option>
          </select>
        </label>

        <label className="grid-usuario__field">
          <span>Tarefa (ID)</span>
          <input
            type="text"
            value={this.state.tsk_id}
            onChange={(e) => this.setState({ tsk_id: e.target.value })}
          />
        </label>

        {this.renderSelectField(
          "Usuário",
          this.state.optionsAgent,
          this.state.age_id,
          (value) => this.setState({ age_id: value }),
          customStyles,
          selectTheme
        )}

        {this.renderSelectField(
          "Equipe",
          this.state.optionsTeam,
          this.state.tea_id,
          (value) => this.setState({ tea_id: value }),
          customStyles,
          selectTheme
        )}

        {this.renderSelectField(
          "Local",
          this.state.optionsLocal,
          this.state.loc_id,
          (value) => this.setState({ loc_id: value }),
          customStyles,
          selectTheme
        )}

        {this.renderSelectField(
          "Patrimônio",
          this.state.optionsAsset,
          this.state.ast_id,
          (value) => this.setState({ ast_id: value }),
          customStyles,
          selectTheme
        )}

        <label className="grid-usuario__field">
          <span>ID para integração</span>
          <input
            type="text"
            value={this.state.tsk_integrationid}
            onChange={(e) => this.setState({ tsk_integrationid: e.target.value })}
          />
        </label>

        <label className="grid-usuario__field">
          <span>Observação</span>
          <input
            type="text"
            value={this.state.tsk_observation}
            onChange={(e) => this.setState({ tsk_observation: e.target.value })}
          />
        </label>

        <div className="grid-task__advanced-dates-row">
          <label className="grid-usuario__field">
            <span>Data inicial</span>
            <input
              type="date"
              value={this.state.startdate}
              onChange={(e) => this.setState({ startdate: e.target.value })}
            />
          </label>

          <label className="grid-usuario__field">
            <span>Data final</span>
            <input
              type="date"
              value={this.state.enddate}
              onChange={(e) => this.setState({ enddate: e.target.value })}
            />
          </label>

          <label className="grid-usuario__field">
            <span>Última atividade (de)</span>
            <input
              type="date"
              value={this.state.startdateUlt}
              onChange={(e) => this.setState({ startdateUlt: e.target.value })}
            />
          </label>

          <label className="grid-usuario__field">
            <span>Última atividade (até)</span>
            <input
              type="date"
              value={this.state.enddateUlt}
              onChange={(e) => this.setState({ enddateUlt: e.target.value })}
            />
          </label>
        </div>

        {this.renderSelectField(
          "Situação",
          this.state.optionsTasksituation,
          this.state.stn_id,
          (value) => this.setState({ stn_id: value }),
          customStyles,
          selectTheme
        )}

        {this.renderSelectField(
          "Tipo de tarefa",
          this.state.optionsTasktype,
          this.state.tty_id,
          (value) => this.setState({ tty_id: value }),
          customStyles,
          selectTheme
        )}

        {this.renderSelectField(
          "Tipo corretiva",
          this.state.optionsCorrectivetype,
          this.state.crt_id,
          (value) => this.setState({ crt_id: value }),
          customStyles,
          selectTheme
        )}

        {this.renderSelectField(
          "Tipo preventiva",
          this.state.optionsPreventivetype,
          this.state.pvt_id,
          (value) => this.setState({ pvt_id: value }),
          customStyles,
          selectTheme
        )}

        <label className="grid-usuario__field">
          <span>ID planejador</span>
          <input
            type="text"
            value={this.state.pla_id}
            onChange={(e) => this.setState({ pla_id: e.target.value })}
          />
        </label>
      </div>

      <div className="grid-usuario__advanced-actions">
        <button type="button" className="grid-usuario__apply-btn" onClick={this.do_search}>
          Aplicar filtros
        </button>
      </div>
    </div>
  );

  render() {

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        background: "#fff",
        minHeight: "38px",
        height: "38px",
        borderColor: state.isFocused ? "#3962ac" : "#e2e8f0",
        borderRadius: "0.75rem",
        fontSize: "0.75rem",
        boxShadow: "none",
      }),
      valueContainer: (provided) => ({
        ...provided,
        height: "38px",
        padding: "0 8px",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0",
        fontSize: 12,
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "38px",
      }),
      menu: (provided) => ({
        ...provided,
        fontSize: "0.75rem",
        zIndex: 20,
      }),
    };

    const selectTheme = (theme) => ({
      ...theme,
      borderRadius: 8,
      colors: {
        ...theme.colors,
        primary25: "#eef2ff",
        primary: "#3962ac",
      },
    });

    const isTaskPage = this.props.pag === "task";
    const situationOptions = (this.state.optionsTasksituation || []).map((opt) => ({
      value: opt.value,
      label: opt.label,
    }));

    const viewModeClass = isTaskPage ? ` grid-view--${this.state.mobileViewMode}` : "";

    return (
      <div className={`grid-usuario${viewModeClass}`}>
        {isTaskPage ? (
          <div className="grid-usuario__hero">
            <div className="grid-usuario__hero-glow" aria-hidden />
            <div className="grid-usuario__hero-text">
              <h2 className="grid-usuario__hero-title">Gestão de Tarefas</h2>
              <p className="grid-usuario__hero-subtitle">
                Consulte, filtre e gerencie tarefas, direcionamento e campos customizados.
              </p>
            </div>
            <GridHeroActions
              mode={this.state.mobileViewMode}
              onToggle={this.toggleMobileViewMode}
              toolbar={
                this.props.onCancelTasks || this.props.onViewGps ? (
                  <TaskPageOptions
                    onQuickDirection={this.props.onQuickDirection}
                    onCustomFields={this.props.onCustomFields}
                    onCancelTasks={this.props.onCancelTasks || (() => {})}
                    onViewGps={this.props.onViewGps || (() => {})}
                  />
                ) : undefined
              }
            >
              <Link to={this.props.fromAdd} className="grid-usuario__hero-btn">
                <FaPlus size={16} aria-hidden />
                <span>Nova Tarefa</span>
              </Link>
            </GridHeroActions>
          </div>
        ) : null}

        {isTaskPage ? (
          <GridFiltersBar
            searchQuery={this.state.search || ""}
            onSearchChange={(value) => this.setState({ search: value })}
            onSearch={this.do_search}
            searchPlaceholder="Pesquisar por id, local, usuário ou observação..."
            searchAriaLabel="Pesquisar tarefas"
            filterValue={this.state.stn_id || ""}
            onFilterChange={this.handleSituationFilterChange}
            filterAriaLabel="Filtrar por situação"
            filterEmptyLabel="Filtrar por Situação"
            filterOptions={situationOptions}
            totalShowing={this.state.tableData.length}
            showAdvanced={this.state.clickedtask}
            onToggleAdvanced={this.exibirFiltro}
            hasActiveFilters={this.hasActiveFilters()}
            onClear={this.clear_search}
          />
        ) : null}

        {this.state.clickedtask ? this.renderAdvancedFilters(customStyles, selectTheme) : null}

        {this.state.isLoading ? (
          isTaskPage ? (
            <TaskGridLoadingPanel />
          ) : (
            <div className="grid-usuario__loading">
              <div className="grid-usuario__skeleton-row" />
              <div className="grid-usuario__skeleton-row" />
              <div className="grid-usuario__skeleton-row" />
            </div>
          )
        ) : this.state.tableData.length > 0 ? (
          <>
            <div className="user-table">
              <div className="user-table__scroll">
                <table className="user-table__table">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onChange={this.toggleSelectAll}
                          checked={this.areAllChecked()}
                          aria-label="Selecionar todas"
                        />
                      </th>
                      <th>{this.props.th2}</th>
                      <th>{this.props.th3}</th>
                      <th>{this.props.th4}</th>
                      <th>{this.props.th5}</th>
                      <th>{this.props.th6}</th>
                      <th>{this.props.th8}</th>
                      <th>{this.props.th7}</th>
                      <th>AÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.tableData.map((tdata) => {
                      const rowId = Object.values(tdata)[0];
                      const onde =
                        Object.values(tdata)[this.props.col3] === null ||
                        Object.values(tdata)[this.props.col3] === ""
                          ? Object.values(tdata)[this.props.col4]
                          : Object.values(tdata)[this.props.col3];

                      return (
                        <tr key={rowId} className="user-table__row">
                          <td
                            className="user-table__cell user-table__cell--center"
                            data-label="Selecionar"
                          >
                            <input
                              type="checkbox"
                              value={String(tdata.tsk_accesstoken)}
                              checked={this.state.isChecked.includes(
                                String(tdata.tsk_accesstoken)
                              )}
                              onChange={this.handleCheckbox}
                            />
                          </td>
                          <td
                            className="user-table__cell user-table__cell--center"
                            data-label={this.props.th2}
                          >
                            <span className="user-table__id">{Object.values(tdata)[this.props.col2]}</span>
                          </td>
                          <td className="user-table__cell" data-label={this.props.th3}>
                            <span className="user-table__name">{onde}</span>
                          </td>
                          <td className="user-table__cell" data-label={this.props.th4}>
                            <span className="user-table__name">
                              {Object.values(tdata)[this.props.col5]}
                            </span>
                          </td>
                          <td className="user-table__cell" data-label={this.props.th5}>
                            <span className="user-table__date">
                              {Object.values(tdata)[this.props.col6]}
                            </span>
                          </td>
                          <td className="user-table__cell" data-label={this.props.th6}>
                            <span className="user-table__date">
                              {Object.values(tdata)[this.props.col7]}
                            </span>
                          </td>
                          <td className="user-table__cell" data-label={this.props.th8}>
                            <span className="user-table__name">
                              {Object.values(tdata)[this.props.col13]}
                            </span>
                          </td>
                          <td className="user-table__cell" data-label={this.props.th7}>
                            <span className="user-table__name">
                              {Object.values(tdata)[this.props.col11]}
                            </span>
                          </td>
                          <td
                            className="user-table__cell user-table__cell--actions"
                            data-label="Ações"
                          >
                            <div className="user-table__actions">
                              <Link to={`${this.props.fromEdit}/${rowId}`}>
                                <button
                                  type="button"
                                  className="user-table__action-btn"
                                  title="Editar"
                                >
                                  <FaPen />
                                </button>
                              </Link>
                              <button
                                type="button"
                                className="user-table__action-btn"
                                title="Copiar"
                                onClick={() => this.props.copiarTask(tdata)}
                              >
                                <FaCopy />
                              </button>
                              <button
                                type="button"
                                className="user-table__action-btn"
                                title="Situação"
                                onClick={() => this.props.consultarSituacao(tdata)}
                              >
                                <FaList />
                              </button>
                              <Link
                                to={`${this.props.fromvisu}/${Object.values(tdata)[this.props.col8]}/${rowId}`}
                              >
                                <button
                                  type="button"
                                  className="user-table__action-btn"
                                  title="Visualizar"
                                >
                                  <FaSearch />
                                </button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <GridTableFooter
                pagAtual={this.state.pagAtual}
                pageCount={this.state.pageCount}
                totalRecords={this.state.length}
                forcePage={this.state.forcePage}
                onPageChange={this.handlePageClick}
              />
            </div>
          </>
        ) : (
          <div className="grid-usuario__empty">
            <h3>Nenhum resultado encontrado</h3>
            <p>Tente ajustar os termos da busca ou remova os filtros adicionais.</p>
            {this.hasActiveFilters() ? (
              <button type="button" className="grid-usuario__empty-btn" onClick={this.clear_search}>
                Limpar busca e filtros
              </button>
            ) : null}
          </div>
        )}

        <ModalPrincipal isOpen={this.state.token}>
          <div className='container-modal-alert'>
            <div className='div-alert'>
              <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
              <div className='btn-alert' onClick={this.props.fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>
          </div>
        </ModalPrincipal>


        <ModalPrincipal isOpen={this.state.Nacesso}>
          <div className='container-modal-alert'>
            <div className='div-alert'>
              <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
              <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
              <div className='div-info-alert'><span className="info-alert">Não foi possível concluir sua solicitação.</span></div>
              <div className='btn-alert' onClick={this.funcNsolicitacao}><span className="btn-alert-lab">OK</span></div>
            </div>
          </div>
        </ModalPrincipal>

      </div>
    );
  }
}

export default Child;
